import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Property } from '@app/_models/propery.model';
import { PropertyService } from '@app/_services/property.service';
import { environment } from '@environments/environment';
import { faSearch, faBuilding, faArrowRight, faHouse } from '@fortawesome/free-solid-svg-icons';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-select-property',
    templateUrl: './select-property.component.html',
    styleUrls: ['./select-property.component.css'],
    standalone: false
})
export class SelectPropertyComponent implements OnInit {

  loading = false;
  searchText: any;
  
  //communities: Community[];
  properties!: Property[];

  faSearch = faSearch;
  faHouse = faHouse;
  faBuilding = faBuilding;
  faArrowRight = faArrowRight;
  
  constructor(private propertyService: PropertyService, 
    private router: Router,
    ) { }

  ngOnInit() {
    this.loading = true;
    this.propertyService.getAll().pipe(first()).subscribe(properties => {
      this.loading = false;
      this.properties = properties;
    });
  }

  loadRequestPage(property: any) {
    if (!environment.production) {
      console.log('Property selected: ',property);
    }   
    localStorage.setItem("property_id", property.id);
    localStorage.setItem('property_name', property.name);
    localStorage.setItem('property_address', property.address);
    
    this.router.navigate(['/request-access']);  
  }



}
